if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index~21": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"node_modules_pnpm_moment_2_30_1_node_modules_moment_locale_sync_recursive_-src_wab_client_com-25c0c6": 1,
"node_modules_pnpm_raw-loader_4_0_2_webpack_5_98_0__swc_core_1_15_43__swc_helpers_0_5_23__esbu-fc86a8": 1,
"src_wab_client_activate-theme_ts-src_wab_client_code-components_code-presets_ts-src_wab_clien-8e96df": 1,
"src_wab_client_components_ChangePasswordModal_tsx-src_wab_client_plasmic_plasmic_kit_user_set-8ed163": 1,
"src_wab_client_components_EditableResourceName_tsx-src_wab_client_components_HostConfig_tsx-s-d9df0f": 1,
"src_wab_client_components_NewProjectModal_tsx-src_wab_client_components_ProjectListItem_tsx-s-a9bcd4": 1,
"src_wab_client_components_QueryBuilder_QueryBuilder_module_scss-src_wab_client_components_Bot-a02a41": 1,
"src_wab_client_components_SimpleConfetti_tsx-src_wab_client_components_TopFrame_TopBar_Spinne-49ac39": 1,
"src_wab_client_components_app-auth_ViewAsButton_tsx-src_wab_client_components_canvas_CanvasDn-268e66": 1,
"src_wab_client_components_cms_CmsRoot_tsx-src_wab_client_plasmic_plasmic_kit_design_system_Pl-bcde67": 1,
"src_wab_client_components_dashboard_AllProjectsPage_tsx": 1,
"src_wab_client_components_dashboard_DefaultLayout_tsx-src_wab_client_components_modals_Conten-ef5129": 1,
"src_wab_client_components_dashboard_DefaultTeamLayout_tsx-src_wab_client_components_dashboard-61e4d1": 1,
"src_wab_client_components_dashboard_MyPlayground_tsx": 1,
"src_wab_client_components_dashboard_SettingsPage_tsx-src_wab_client_plasmic_plasmic_kit_dashb-4a053a": 1,
"src_wab_client_components_dashboard_TeamPage_tsx": 1,
"src_wab_client_components_dashboard_TeamSettingsPage_tsx": 1,
"src_wab_client_components_dashboard_WorkspacePage_tsx": 1,
"src_wab_client_components_docs_DocsPortal_tsx": 1,
"src_wab_client_components_grouping_VirtualTree_tsx-src_wab_client_components_insert-panel_Car-dc6c19": 1,
"src_wab_client_components_pages_InitTokenPage_tsx": 1,
"src_wab_client_components_sidebar-tabs_LayoutSection_tsx-src_wab_client_components_sidebar-ta-7875a2": 1,
"src_wab_client_components_sidebar-tabs_ProjectPanel_ProjectPanelTop_tsx-src_wab_client_compon-5b759a": 1,
"src_wab_client_components_sidebar-tabs_Sections_tsx-src_wab_client_components_sidebar-tabs_Se-ab7dee": 1,
"src_wab_client_components_studio_arenas_GridFramesLayout_module_sass-src_wab_client_component-1d79bd": 1,
"src_wab_client_components_top-bar_ArenaSwitcher_tsx-src_wab_client_components_top-bar_BranchS-66d9b3": 1,
"src_wab_client_components_tpl-menu_tsx-src_wab_client_components_user-mentions_UserMentionDis-d2bd44": 1,
"src_wab_client_components_webhooks_plasmic_plasmic_kit_continuous_deployment_PlasmicWebhooksI-b6b430": 1,
"src_wab_client_components_widgets_ColorPicker_Pickr_overrides_scss-src_wab_client_api-hooks_t-bb3e2a": 1,
"src_wab_client_components_widgets_Select_tsx-src_wab_client_plasmic_plasmic_kit_PlasmicIcon__-e0e179": 1,
"src_wab_client_hooks_usePreventDefaultBrowserPinchToZoomBehavior_ts-src_wab_client_plasmic_pl-5e2163": 1,
"src_wab_client_plasmic_PP__plasmickit_left_pane_css-src_wab_client_plasmic_PP__plasmickit_sha-c58f08": 1,
"src_wab_client_plasmic_PP__plasmickit_settings_css": 1,
"src_wab_client_plasmic_plasmic_kit_PlasmicIcon__After_tsx-src_wab_client_plasmic_plasmic_kit_-cd335b": 1,
"src_wab_client_plasmic_plasmic_kit_PlasmicIcon__AlignCenter_tsx-src_wab_client_plasmic_plasmi-7178f7": 1,
"src_wab_client_plasmic_plasmic_kit_comments_PlasmicAddCommentMarker_tsx-src_wab_client_plasmi-b10de4": 1,
"src_wab_client_plasmic_plasmic_kit_design_system_PlasmicDialog_tsx-src_wab_client_plasmic_pla-873c6f": 1,
"src_wab_client_plasmic_plasmic_kit_design_system_images_eyeSvg_svg-src_wab_client_plasmic_pla-c420a7": 1,
"src_wab_client_plasmic_plasmic_kit_end_user_management_PlasmicActivityRow_tsx-src_wab_client_-41e42f": 1,
"src_wab_client_plasmic_plasmic_kit_end_user_management_PlasmicPermissionRule_tsx-src_wab_clie-bbb484": 1,
"src_wab_client_plasmic_plasmic_kit_multiplayer_ui_PlasmicMultiplayerCursor_tsx-src_wab_client-7f828e": 1,
"src_wab_client_plasmic_plasmic_kit_new_component_PlasmicNewComponentItem_tsx-src_wab_client_p-122f86": 1,
"src_wab_client_plasmic_plasmic_kit_style_controls_images_image_png-src_wab_client_plasmic_pla-7d2583": 1,
"src_wab_client_plasmic_plasmic_kit_user_mentions_PlasmicUserList_tsx-src_wab_client_plasmic_p-cedf07": 1,
"src_wab_client_plasmic_plasmic_kit_user_settings_PlasmicStyleTokensProvider_tsx-src_wab_clien-1772d3": 1,
"vendors-node_modules_pnpm_graphiql_plugin-explorer_3_2_3__graphiql_react_0_26_2__codemirror_l-bee888": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_base_browser-a1821e": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_editor_brows-435fc2": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_editor_brows-6bcb55": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_editor_brows-e5ab78": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_editor_contr-33b432": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_editor_contr-36ed7f": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_editor_contr-506c7d": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_editor_stand-52366a": 1,
"vendors-node_modules_pnpm_monaco-editor_0_50_0_node_modules_monaco-editor_esm_vs_platform_acc-607ed5": 1,
"vendors-node_modules_pnpm_plasmicpkgs_react-aria_0_0_199__plasmicapp_host_2_0_19_react-dom_18-986610": 1,
"vendors-node_modules_pnpm_tinymce_6_8_6_node_modules_tinymce_skins_ui_tinymce-5_skin_min_css--16a3fd": 1,
"vendors-node_modules_pnpm_xyflow_react_12_10_2__types_react_18_3_18_immer_10_2_0_react-dom_18-7a7ee0": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload